import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from '../components/admin/AdminLayout';
import PhotoGallery from '../components/admin/PhotoGallery';
import TagsAndAccess from '../components/admin/TagsAndAccess';

export default function AdminDashboard() {
  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<Navigate to="/admin/photos" replace />} />
        <Route path="/photos" element={<PhotoGallery />} />
        <Route path="/tags" element={<TagsAndAccess />} />
        {/* Redirect old links route to tags */}
        <Route path="/links" element={<Navigate to="/admin/tags" replace />} />
      </Routes>
    </AdminLayout>
  );
}